import { render, staticRenderFns } from "./ProposalView.vue?vue&type=template&id=b3be18ca&scoped=true&lang=pug"
import script from "./ProposalView.vue?vue&type=script&lang=js"
export * from "./ProposalView.vue?vue&type=script&lang=js"
import style0 from "./ProposalView.vue?vue&type=style&index=0&id=b3be18ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3be18ca",
  null
  
)

export default component.exports